import WebsiteModal from "modal/WebsiteModal";

export default class MoreInfoModal extends WebsiteModal {
    constructor(data) {
        super();
        this.data = data;
    }

    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--more-info"}, [
                eotwJSXFactory('div', {className: "modal__bg js-close-modal"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('button', {className: "modal__close js-close-modal"}),
                    eotwJSXFactory('div', {className: "modal__content content-section"}, [
                        eotwJSXFactory('h2', {className: "heading heading--4"}, [this.data.title]),
                        eotwJSXFactory('p', null, [this.data.description, "."])
                    ])
                ])
            ])
        );
    }

    show() {
        super.show();
    }
}


